module.exports = __webpack_public_path__ + "static/3b884fec6645bfa7613b5ef69a27816d8b081ab37ad51edbc39a391142a1fcbb-e95ea3591b5aabb59847ca1f3a4db8c9.png";